import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { RoofTypeRow } from "../../types";
import { useStyles } from "./styles";

type Props = {
  rows: RoofTypeRow[];
  loading?: boolean;
};

const RoofTypeTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const columns = useMemo(
    () => [
      {
        id: "beamTypeId",
        label: t("ROOF_TYPE.TABLE.NUMBER"),
        align: "right",
        width: "56px",
        minWidth: "56px",
        format: (row: RoofTypeRow) => (
          <span className={styles.numberCell}>{row.beamTypeId}</span>
        ),
      },
      {
        id: "beamTypeDesc",
        label: t("ROOF_TYPE.TABLE.DESCRIPTION"),
        align: "right",
        width: "calc((100% - 56px) / 2)",
        minWidth: "calc((100% - 56px) / 2)",
        format: (row: RoofTypeRow) => (
          <span className={styles.textCell}>{row.beamTypeDesc}</span>
        ),
      },
      {
        id: "beamMaxHeight",
        label: t("ROOF_TYPE.TABLE.MAX_HEIGHT"),
        align: "right",
        width: "calc((100% - 56px) / 2)",
        minWidth: "calc((100% - 56px) / 2)",
        format: (row: RoofTypeRow) => (
          <span className={styles.numberCell}>{row.beamMaxHeight ?? ""}</span>
        ),
      },
    ],
    [styles, t]
  );

  return (
    <div className={styles.root} dir="rtl">
      <DataTable
        rows={rows}
        columns={columns}
        loading={loading && rows.length === 0}
        serialEnabled={false}
        noDataLabel={t("ROOF_TYPE.EMPTY")}
      />
    </div>
  );
};

export default RoofTypeTable;
